import { black } from "./colors";
export const borderStyle = `2px solid ${black[100]}`;
export const borderStyle2 = `1px solid ${black[100]}`;
export const sidenavWidth = "8rem";
export const sidenavWidthSM = "6.4rem";
